var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLocationPointer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1119_26822)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7148 11.791C14.3717 11.791 15.7148 10.4479 15.7148 8.79102C15.7148 7.13416 14.3717 5.79102 12.7148 5.79102C11.058 5.79102 9.71484 7.13416 9.71484 8.79102C9.71484 10.4479 11.058 11.791 12.7148 11.791Z",
    stroke: "#363636",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7155 11.791C16.4655 17.041 12.7155 23.041 12.7155 23.041C12.7155 23.041 8.96552 17.041 6.71552 11.791C4.46552 6.54102 8.21552 2.04102 12.7155 2.04102C17.2155 2.04102 20.9655 6.54102 18.7155 11.791Z",
    stroke: "#363636",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1119_26822"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.714844 0.541016)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocationPointer);
export default __webpack_public_path__ + "static/media/icon-location-pointer.bbf9b93d01cf4f6b7b6f8fea62b3c493.svg";
export { ForwardRef as ReactComponent };